module.exports = __webpack_public_path__ + "static/media/image-card-4.80f36fd9.png";